import React from 'react';
import { Link } from 'react-router-dom';

import './DevelopmentDevices.scss';

export interface Props {
  items?: string[];
  addClickHandler?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  removeClickHandler?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  settingsClickHandler?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const DevelopmentDevices = (props: Props) => {
  const items = props.items ?? [];

  const alert = items.length > 0 ? '' : (
    <div className="w-100 text-center alert alert-info">
      دستگاهی ثبت نشده است
    </div>
  );

  return (
    <div className="development-devices-component">
      {alert}
      <ul className="devices-list">
        {items.map(item => (
          <li key={item}>
            {item}
            <div className="icons-group">
              <Link to={'/sensors/edit/' + item}>
                <i className="far fa-cog view-icon"></i>
              </Link>
              <i
                className="far fa-times delete-icon"
                onClick={props.removeClickHandler}
                data-serial={item} ></i>
            </div>
          </li>
        ))}
      </ul>
      <button
        onClick={props.addClickHandler}
        className="btn btn-success btn-add-device">
        <i className="far fa-plus ml-2"></i>
          افزودن دستگاه
      </button>
    </div>
  );
}

export default DevelopmentDevices;
